<script setup lang="ts">
import CurrentUser from '@/views/header/CurrentUser.vue';
import ZZC from '@/views/header/ZZCLogo.vue';
import VersionComponent from '@/views/header/VersionComponent.vue';
import CabLink from '@/views/header/CabLink.vue';
import {stateForReporters, fetchAndSetState, startStatePolling, stopStatePolling} from '@/base/TMP_globalState.js';
import {AvailabilityState} from 'common';
import {onMounted, onUnmounted} from 'vue';
import {done, loadingState, reload} from '@/base/loadingState.js';
import LoadingStateView from '@/views/general/LoadingStateView.vue';

onMounted(async () => {
    await reload();
    await fetchAndSetState();
    startStatePolling();
});

onUnmounted(() => {
    stopStatePolling();
});
</script>

<template>
    <div class="h-screen relative">
        <VersionComponent/>

        <div class="flex flex-row backdrop-brightness-90 justify-between" id="mainheader">
            <ZZC/>
            <div class="flex flex-row items-end space-x-4" v-if="stateForReporters!==AvailabilityState.closed">
                <CabLink name="rapporteren"
                         to="/report/rapporteren"
                />
                <CabLink name="beheer"
                         to="/report/beheer"
                />
            </div>
            <CurrentUser/>
        </div>
        <LoadingStateView :state="loadingState" :stateForReporters="stateForReporters"/>
        <router-view v-if="done && stateForReporters!==AvailabilityState.closed"/>
    </div>
</template>
